import { render, staticRenderFns } from "./filterProducts.vue?vue&type=template&id=a0b0a600&"
import script from "./filterProducts.vue?vue&type=script&lang=js&"
export * from "./filterProducts.vue?vue&type=script&lang=js&"
import style0 from "./filterProducts.vue?vue&type=style&index=0&id=a0b0a600&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports